import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Constants } from '@app/constants/constants';
import { MethodsHelper } from '@app/helpers/methods.helper';
import { Branch } from '@app/models/branch';
import { SavingAgreementApproval } from '@app/models/saving-agreement-approval';
import { SavingAgreementCalculateInterest } from '@app/models/saving-agreement-calculate-interest';
import { AuthenticationService } from '@app/services/authentication.service';
import { NotificationService } from "@app/services/notification.service";
import { SavingAgreementsService } from '@app/services/saving-agreements.service';
import {GlobalErrorHandlerService} from "@app/services/global-error-handler.service";

@Component({
    selector: 'app-saving-agreement-interest-calculation-popup',
    templateUrl: './saving-agreement-interest-calculation-popup.component.html',
    styleUrls: ['./saving-agreement-interest-calculation-popup.component.css'],
    standalone: false
})

export class SavingAgreementInterestCalculationPopupComponent implements OnInit {

  @Input() savingAgreementApproval: SavingAgreementApproval;
  @Input() branches: Array<Branch>;

  @Input() displayDialog: boolean;
  @Output() onSubmit = new EventEmitter();
  @Output() onCancel = new EventEmitter();

  @ViewChild('form') form: any;

  submittedForm: boolean = false;
  calculationBranchId: string;

  yearRange: string;
  selectedCurrency: string;
  errorMessage: string | boolean;

  savingAgreementCalculateInterest: SavingAgreementCalculateInterest;

  constructor(
    private authenticationService: AuthenticationService,
    private notificationService: NotificationService,
    private savingAgreementsService: SavingAgreementsService,
    private errorService: GlobalErrorHandlerService) { }

  ngOnInit(): void {
    this.yearRange = MethodsHelper.getYearRange(0);
    if (!MethodsHelper.haveValue(this.calculationBranchId)) {
      this.calculationBranchId = this.authenticationService.getCurrentBranchId();
    }
  }

  ngOnChanges() {
    this.savingAgreementCalculateInterest = new SavingAgreementCalculateInterest();
    this.savingAgreementCalculateInterest.date = MethodsHelper.formatDate(localStorage.getItem('businessDay') ? new Date(localStorage.getItem('businessDay')) : new Date());
    this.getSavingAgreementCalculateInterest();
    this.selectedCurrency = this.getCurrencyCode();
  }

  cancel() {
    this.onCancel.emit();
  }

  onSave() {
    this.saveData();
  }

  validateForm() {
    if (this.form.form) {
      return this.form.form.valid
    }
    return false;
  }

  getCurrencyCode() {
    return this.savingAgreementCalculateInterest?.currency;
  }

  getSavingAgreementCalculateInterest() {
    if (this.savingAgreementApproval?.id) {
      this.getCalculateInterest(this.savingAgreementApproval.id)
    }
  }

  getCalculateInterest(savingAgreementId) {
    this.savingAgreementsService.getCalculate(savingAgreementId, this.savingAgreementCalculateInterest.date).subscribe({
      next: (data) => {
        // data.date = new Date(data.date);
        this.savingAgreementCalculateInterest = data;
        this.selectedCurrency = this.getCurrencyCode();
      },
      error: (error) => this.handleError(error)
    });
  }

  formatDate(value) {
    let date = new Date(value);
    const day = date.toLocaleString('default', { day: '2-digit' });
    const month = date.toLocaleString('default', { month: 'numeric' });
    const year = date.toLocaleString('default', { year: 'numeric' });
    return year + '-' + month + '-' + day;
  }

  formatStringDate(value) {
    const day = value.toLocaleString('default', { day: '2-digit' });
    const month = value.toLocaleString('default', { month: 'numeric' });
    const year = value.toLocaleString('default', { year: 'numeric' });
    return day + '-' + month + '-' + year;
  }

  saveData() {
    this.submittedForm = true;
    if (this.validateForm()) {
      let submittedData = {
        documentNumber: this.savingAgreementCalculateInterest.documentNumber,
        date: this.savingAgreementCalculateInterest.date,
        branchId: this.calculationBranchId,
        description: this.savingAgreementCalculateInterest.description,
        initiatedUserId: this.authenticationService.getCurrentUserId(),
        channelCode: Constants.CHANNEL.CHANNEL_CODE,
      };
      this.savingAgreementsService.calculate(this.savingAgreementApproval.id, submittedData).subscribe({
        next: () => {
          this.notificationService.showHTMLMessage("<i class='fa fa-check-circle' style='line-height: 2'></i> <p>" + `Calculation interest has been successfully done.` + "</p>", "");
          this.onSubmit.emit();
        },
        error: (error) => this.handleError(error)
      });
    }
  }

  onCalculationAmountChange(value) {
    this.savingAgreementCalculateInterest.interestAmount = value;
  }

  handleError(error) {
    this.errorMessage = this.errorService.handleError(error);
    if (this.errorMessage) {
      this.notificationService.showErrorMessage(this.errorMessage);
    }
  }

}
